import DOMPurify from 'dompurify';
import Cookies from 'js-cookie';
import moment from 'moment';

import { KEY_ANON_COMMENT } from 'constants/cookie';
import { EMBED_PLAY_VIDEO_AT_TS } from 'constants/messages';
import { getGraphQLClient } from 'utilities/graphql';
import { replaceURLs } from 'utilities/mediumHelpers';
import { goToNewTab } from 'utilities/url';

import CreateComment from './CreateVideoComment.gql';

const ALLOWED_TAGS = ['a', 'b', 'br', 'p', 'div', 'u', 'i', 'span'];

const ALLOWED_ATTRIBUTES = ['href', 'data-seconds', 'class', 'target'];

const NO_HTML_SANITATION_BEFORE = '2018-02-15T22:00:00-0000';

export const getFormattedDateForHeader = createdAt => {
  return `${moment().from(createdAt, true)} ago`;
};

export const playVideoAtTimestamp = e => {
  e.preventDefault();
  e.stopPropagation();

  if (e.target.className.indexOf('external-link') > -1) {
    return goToNewTab(e.target.href);
  }

  const secondsData = e.target.getAttribute('data-seconds');

  if (!secondsData) {
    return;
  }

  const numSeconds = Number(secondsData);

  window.top.postMessage(
    {
      type: EMBED_PLAY_VIDEO_AT_TS,
      numSeconds,
    },
    '*'
  );

  return false;
};

export const sanitizeContent = (comment, allowedTags = ALLOWED_TAGS) => {
  if (moment(comment.createdAt).isBefore(NO_HTML_SANITATION_BEFORE)) {
    return comment.content;
  }

  const sanitizedContent = DOMPurify.sanitize(comment.content, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: ALLOWED_ATTRIBUTES,
  });

  return sanitizedContent;
};

export const userCanDelete = (comment, currentUserIsOwner, user) => {
  if (currentUserIsOwner) {
    return true;
  } else if (user.is_logged_in) {
    return comment.user_id === user.current.id;
  }

  return Cookies.get(KEY_ANON_COMMENT) === comment.anon_user_id;
};

export const isReply = commentOrReply => {
  return Boolean(commentOrReply.comment_post_id);
};

export const createVideoComment = ({
  anonUserName,
  comment,
  parentPostId,
  password,
  timestamp,
  videoId,
}) => {
  const gqlClient = getGraphQLClient();

  const urlInjectedContent = replaceURLs(comment);

  return gqlClient.mutate({
    mutation: CreateComment,
    variables: {
      anonUserName,
      content: urlInjectedContent,
      mentions: [],
      parentPostId: parseInt(parentPostId),
      password,
      timestamp,
      videoId,
    },
  });
};
